import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { systemTransferQueries } from '@/services/systemTransfer/pointsTransfer.queries';
import { useSearch } from '@tanstack/react-router';

export const useSystemTransfer = () => {
  const { sort } = useSearch({
    from: '/(app)/points-management/system-transfer/',
  });
  const { data, isFetched } = useQuery({
    ...systemTransferQueries.list(),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { systemTransferdata: data?.data || [], isFetched };
};
